export default {
	name: "Español",

	'global.itemCounts': `{total, plural,
		=0 {sin contenido}
		other {}
	}{collections, plural,
		=0 {}
		one {una colección}
		other {{collections} colecciones}
	}{both, select,
		true {, }
		other {}
	}{stories, plural,
		=0 {}
		one {una historia}
		other {{stories} historias}
	}`,

	'cover.stories': `{itemCount, plural,
		one {historia}
		other {historias}
	}`,

	'searchbutton.placeholder': 'Buscar...',

	'flow.empty': 'No hay contenido que mostrar.',

    "search.empty": "Su búsqueda no ha dado ningún resultado.",

	'forms.submitted': 'Sus entradas se enviaron correctamente.',
	'forms.errored': 'Hubo un problema con sus datos de formulario.',
	'forms.required': 'Este campo es necesario para enviar el formulario.',
	'forms.close': 'Gracias',

	'prevnext.prev': 'historia anterior',
	'prevnext.next': 'historia siguiente',

	'navigation.back': 'volver',
	
	'share.back': 'volver',
	'share.embed': 'empotrar',
	'share.share': 'compartir',
	'share.cover': 'Portada',
	'share.custom': 'elemento personalizado',
	'share.inline': 'empotrar directamente',
	'share.customhere': 'INSERTAR SU PROPIO ELEMENTO AQUÍ',
	'share.scriptonce': 'El script anterior debe incluirse sólo una vez por página',
	'share.FacebookLabel': 'Compartir en Facebook',
	'share.TwitterLabel': 'Tweet',
	'share.TwitterText': '{title}',
	'share.EmbedLabel': 'empotrar',

	'more.showCollection': 'Mostrar todas las historias',
	'more.showMore': 'Mostrar historias anteriores',
	'more.showMoreBack': '«',
	'more.showMoreSearch': 'Mostrar más contenidos',
	'more.showMoreSearchBack': '«',

	'multislider.showAll': 'Mostrar todas las historias',

	'passwordScreen.passwordPlaceholder': 'contraseña',
	'passwordScreen.usernamePlaceholder': 'usuario',
	'passwordScreen.subTitle': 'es una {type, select, story {historia} collection {colección}} protegida',
	'passwordScreen.submit': 'enviar',
	'passwordScreen.error': 'autorización no es posible!',

	'like.label': 'gustos {likeCount, number}',
	'like.noLikeLabel': 'Me gusta',

    "forward.title": "Redirigiendo",
    "forward.message": "Está siendo redirigido a: {href}",
};



// WEBPACK FOOTER //
// ./lib/locales/es.js